import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { DxChartComponent, DxPivotGridComponent } from 'devextreme-angular';
import DataSource from 'devextreme/data/data_source';
import PivotGridDataSource from 'devextreme/ui/pivot_grid/data_source';
import { filter } from 'lodash';

@Component({
  selector: 'app-fields-interventions-tractors-speed-working-area-time-report',
  templateUrl: './fields-interventions-tractors-speed-working-area-time-report.component.html',
  styleUrls: ['./fields-interventions-tractors-speed-working-area-time-report.component.scss']
})
export class FieldsInterventionsTractorsSpeedWorkingAreaTimeReportComponent implements OnInit {

  chartHeight: number;

  @Input()
  toolbarDs: DataSource;
  @Input()
  dataSource: PivotGridDataSource;
  @Input()
  currentReportType: any;
  @Input()
  reportCurrentViewModes: any;
  @Input()
  width: number;
  @Input()
  height: number;

  @ViewChild(DxChartComponent, { static: false })
  chart: DxChartComponent;
  @ViewChild(DxPivotGridComponent, { static: false })
  pivotGrid: DxPivotGridComponent;

  ngOnInit(): void {
    // Set fields
    this.dataSource.fields([{
      caption: 'Parcelle',
      dataField: 'field.name',
      area: 'row'
    }, {
      caption: 'Tracteur',
      dataField: 'tractor_name',
      allowFiltering: true,
      area: 'row'
    }, {
      caption: 'Outil',
      dataField: 'trailer_name',
      width: 150,
      area: 'row'
    }, {
      caption: 'Mois',
      dataField: 'start_time',
      dataType: 'date',
      groupInterval: 'month',
      area: 'column'
    }, {
      caption: 'Ha/h',
      dataField: 'working_hectare_per_hour',
      dataType: 'number',
      summaryType: 'avg',
      format: { type: 'fixedPoint', precision: 2 },
      area: 'data'
    }, {
      caption: 'KM/H',
      dataField: 'working_in_field_speed_avg',
      dataType: 'number',
      summaryType: 'avg',
      format: { type: 'fixedPoint', precision: 2 },
      area: 'data'
    }, {
      caption: 'Largeur de Travail (m)',
      dataField: 'trailer_width',
      allowFiltering: true,
      visible: true,
      summaryType: 'avg',
      format: (value) => {
        return (value as number / 100).toFixed(2);
      },
      area: 'data'
    }, {
      caption: 'Puissance',
      dataField: 'tractor_engine_power',
      allowFiltering: true,
      summaryType: 'avg',
      area: 'data'
    }]);

    this.chartHeight = filter(this.dataSource.fields(), (f) => {
      return f.area === 'data' && f.visible !== false;
    }).length * 350;

    this.toolbarDs.store().push([{
      type: 'update',
      data: {
        options: {
          onClick: () => {
            this.pivotGrid.instance.getFieldChooserPopup().show();
          }
        }
      },
      key: 'filter',
    },
    {
      type: 'update',
      data: {
        options: {
          onClick: () => {
            this.dataSource.reload();
          }
        }
      },
      key: 'refresh',
    }]);
  }

  ngAfterViewInit(): void {
    this.pivotGrid.instance.bindChart(this.chart.instance, {
      dataFieldsDisplayMode: 'splitAxes',
      alternateDataFields: false,
      inverted: true,
      customizeSeries: (seriesName, seriesOptions) => {
        return seriesOptions; // This line is optional
      },
      customizeChart: (chartOptions) => {
        return chartOptions; // This line is optional
      },
    });

    // Assign the data source
    this.pivotGrid.instance.option('dataSource', this.dataSource);
  }

  customizeTooltip(args) {
    return {
      html: args.seriesName + ': ' + args.valueText
    };
  }
}
